import { ErrorHandler, inject, Injectable } from '@angular/core';
import { ErrorHandlingService } from '../services/error-handling.service';
import { NotificationService } from '../services/notification.service';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class GlobalErrorHandler extends ErrorHandler {
  private errorHandlingService = inject(ErrorHandlingService);
  private notificationService = inject(NotificationService);

  override handleError(error: unknown): void {
    if (error instanceof HttpErrorResponse) {
      const errorInfo = this.errorHandlingService.handleError(error);

      if (errorInfo.shouldShowToUser) {
        try {
          this.notificationService.showError(errorInfo.userMessage);
        } catch (toastError) {
          console.error('❌ Error al mostrar toast:', toastError);
        }
      } else {
        console.log('⏭️ GlobalErrorHandler - shouldShowToUser es false, no mostrar toast');
      }
    } else {
      //console.log('🔧 GlobalErrorHandler - Error no HTTP:', error);
      const message = error instanceof Error ? error.message : 'Error desconocido';

      // Ignorar errores conocidos de PrimeNG Calendar
      const isPrimeNGCalendarError =
        message.includes("Cannot read properties of undefined (reading 'addEventListener')") ||
        message.includes("Cannot read properties of null (reading 'focus')");

      if (!isPrimeNGCalendarError) {
        try {
          this.notificationService.showError('Ha ocurrido un error inesperado');
        } catch (toastError) {
          console.error('❌ Error al mostrar toast JavaScript:', toastError);
        }
      }

      console.error('Javascript Error:', {
        message,
        stack: error instanceof Error ? error.stack : 'No stack trace available',
        error,
      });
    }
    super.handleError(error);
  }
}
